"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MarqueeBox;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _fastMarquee = _interopRequireDefault(require("./common/fast-marquee"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
const Item = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Item",
  class: "pl-iot9qfa"
});

/**
 * MarqueeBox Component.
 *
 * @param {Object} props React props
 * @param {Node} props.children Marquee Component
 * @param {Number} props.speed Slide Speed
 * @param {Boolean} props.play Play State
 * @param {String} props.direction Slide Animation Direction
 * @returns {React.ReactElement} MarqueeBox Component
 * @public
 */

function MarqueeBox({
  children,
  speed = 20,
  play,
  direction = 'left'
}) {
  if (!children) return null;
  return /*#__PURE__*/_react.default.createElement(Item, {
    style: {
      whiteSpace: 'nowrap'
    },
    "data-cy": "template-wall-item"
  }, /*#__PURE__*/_react.default.createElement(_fastMarquee.default, {
    speed: speed,
    play: play,
    pauseOnHover: true,
    direction: direction
  }, children));
}
MarqueeBox.propTypes = {
  children: _propTypes.default.node,
  play: _propTypes.default.bool,
  speed: _propTypes.default.number,
  direction: _propTypes.default.oneOf(['left', 'right'])
};